const ApiPaths = {
  categoryPath: '/category/list',
  loginPath: '/auth/login',
  signupPath: '/auth/signup',
  orderPath: '/order/list',
  wishlistPath: '/wishlist',
  addressesPath: '/address/list',
  userInfoPath: '/system/get-profile',
  userInfoUpdatePath: '/system/profile',
  productsPath: '/product/list',
  shopPath: '/shop/list',
  favShops: '/shop/followed',
  attributePath: '/attribute/list',
  priceRange: '/product/price-range',
  cityPath: '/system/cities',
  provincePath: '/system/provinces',
  countryPath: '/system/countries',
  cartPath: '/cart',
  couponPath: '/coupon/validate',
  cartSummary: '/cart/summary',
  blogPath: '/system/blogs',
  servicePath: '/shop/services/service',

  brandList: '/system/brands',
  brandCountries: '/system/brands/countries',
  modelList: '/system/car-models',
  colorList: '/system/colors',
  tagList: '/system/tags',
  blogCategoryList: '/system/blog-categories',
  commentList: '/system/comment',
  // commentList: '/shop/services/comment',

  // userPlateList: '/system/users/plates',
  nearbyShops: '/shop/system/get_nearby',
  userAddressList: '/shop/system/address',
  shopServices: '/shop/services/service-shop',
  sendCodePath: '/auth/send-code',
  confirmCode: '/auth/confirm-code',
  serviceCategoryPath: '/system/categories',
  serviceSubCategoryPath: '/system/sub-categories',
  najiService: '/system/inquiry',
  serviceHistory: '/system/fetch-history',
  platesList: '/system/user-plates',
  subUserLevel1: '/system/inquiry-initial-register',
  subUserLevel2: '/system/inquiry-register',
  serviceInquery: '/system/inquiry',
  setDefaultPath: '/system/set-default',
  getDefaultPath: '/system/get-default',
  getWallet: '/system/get-wallet',
  subuserListPath: '/system/sub-users',
  subuserSync: '/system/sync',
  removeSubUser: '/system/remove-subuser',
  paymentPath: '/system/start-payment',
  transactionList: '/system/transaction-list',
  myplatesList: '/system/fetch-all-violations',
  myplatesHistoryItems: '/system/fetch-all-violations-items',
  allPlatesInq: '/system/all-violations',
  deleteAccountPath: '/system/remove-user',
  myplatesInqPrice: '/system/all-violations-price',
  transactionListBank: '/system/bankpayment-list',
  transactionListExcel: '/system/transaction-excel',
  transactionListExcelBank: '/system/bankpayment-excel',
  transactionSum: '/system/transaction-sum',
  fetchNoAuth: '/system/fetch-noauth',

  // ----------------- dashboard
  userShops: '/user/shops/list',
  userProductList: '/user/products/list',
  productCategoryPath: '/product/category/list',
};
export default ApiPaths;
